// extracted by mini-css-extract-plugin
export var backdropBlur = "_cd-0";
export var contentCard = "_cd-5";
export var frame = "_cd-2";
export var image = "_cd-4";
export var imagePane = "_cd-3";
export var modal = "_cd-1";